<template>
  <nd-dialog v-model="visible" close-btn :footer="false">
    <div
      class="dialog-box"
      :class="{hasCoupon}"
      data-sensors-exposure-property-msg_name="PSC_M"
      data-sensors-exposure-property-caseId="PSC_M"
      data-sensors-exposure-event-name="PopupDisplay"
    >
      <div class="title">您获得<span>{{ loanAmount }}元免审</span>额度</div>
      <!-- 优惠券信息 -->
      <coupon-info
        v-if="hasCoupon"
        class="dialog-coupon-info"
        :couponDiscountValue="20"
        :useEndTime="1699147122740"
      />
      <div class="review-button">
        <span class="real-price" @click="jumpBuy" data-sensors-click><template v-if="remainTime>0">限时</template>优惠价 ¥{{ realPrice }}</span>
        <span class="original-price">原价 ¥{{ price }}</span>
        <div class="discount-float" v-if="remainTime>0 && !hasCoupon">
          <van-count-down
            style="display: inline;color: inherit;font-size: inherit;"
            :time="remainTime"
            format="DD天HH时mm分"
          />后涨价
        </div>
      </div>
      <div class="protocol">
        开通即同意<span @click="$emit('to-protocol')">《会员用户协议》</span>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
import { mapActions } from 'vuex'

// 重审卡弹窗
export default {
  name: 'RefusedPrivilegeDialog',
  components: {
    'coupon-info': () => import('@/components/coupon-info/index.vue')
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loanAmount: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: 'credit' // credit: 授信 loan: 提现
    },
    amount: {
      type: Number,
      default: 29.9
    },
    price: {
      type: Number,
      default: 29.9
    },
    // 优惠价
    expirePrice: {
      type: Number,
      default: 0
    },
    // 优惠截止时间
    expireDate: {
      type: Number,
      default: 0
    },
    // 供应商
    supplier: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasCoupon () {
      return !true
    },
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    remainTime () {
      const interval = new Date(this.expireDate).getTime() - new Date().getTime()
      return interval
    },
    realPrice () {
      return this.remainTime > 0 ? this.expirePrice : this.amount
    }
  },
  methods: {
    ...mapActions('vip', ['orderCreateX']),
    // 跳转福利详情页面
    jumpDetail () {
      this.jumpToKingCardPage()
    },
    // 放弃机会
    handleGiveup () {
      this.visible = false
    },
    // 跳转收银台页面
    async jumpBuy () {
      this.$emit('on-buy')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

/deep/.nd-dialog-content {
  .default-content {
      background: none;
      width: 750px;
      height: 1033px;
      padding: 0;
      margin: 0;
  }
}
.dialog-box {
  color: #333333;
  width: 750px;
  height: 1033px;
  background: url(./images/pop_tixian_pass.png) no-repeat center top;
  background-size:680px 100%;
  position: absolute;
  top:0; left:0;
  &.hasCoupon {
    height: 1043px;
    .dialog-coupon-info {
      left:50%;
      transform: translateX(-50%);
      margin-top:410px;
       width: 530px;
       height: 90px;
    }
    .review-button {
      bottom: 100px;
    }
    .protocol {
      bottom: 60px;
    }
  }

  .title {
    font-size: 50px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    span {
      color: #FFEB82;
    }
    margin-top: 320px;
  }
  .review-button {
    width: 530px;
    height: 88px;
    background: linear-gradient(90deg, #FFEB82 0%, #FFD450 100%);
    border-radius: 47px;
    text-align: center;
    position: absolute;
    bottom: 133px;
    left: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    .real-price {
      height: 45px;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #7F3800;
    }
    .original-price {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7F3800;
      padding-top: 5px;
      padding-left: 20px;
      text-decoration: line-through;
    }
    .discount-float {
        position: absolute;
        top: -20px;
        right: 80px;
        height: 40px;
        line-height: 40px;
        background: rgba(0,0,0,0.8);;
        border-radius: 20px 20px 20px 0px;
        padding: 0 20px;
        font-size: 20px;
        color: #FFFFFF;
      }
  }
  .protocol {
    width: 400px;
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 33px;
    position: relative;
    text-align: center;
    span {
      border-bottom: 1px solid #fff;
    }
    position: absolute;
    bottom: 70px;
    width: 100%;

  }
}
</style>
